// Dernier résultat des listes (Historique, Reste à affecter, Tableau de bord), gardé en mémoire le temps
// de la session (perdu au rechargement de la page). Les écrans étant recréés à chaque retour, la liste est
// réaffichée tout de suite depuis ce cache puis rafraîchie en arrière-plan.
//
// Toute fonction serveur absente de LECTURES est considérée comme une modification et vide le cache,
// avant et après son appel : on ne réaffiche jamais une liste qui peut être devenue fausse
// (ex : une commande qui vient d'être affectée).

const MAX_ENTREES = 20;

// Fonctions serveur qui ne modifient aucune donnée affichée dans les listes
const LECTURES = new Set([
  "sessionInit",
  "order.order.list",
  "order.order.get",
  "order.order.dashboard",
  "order.order.getstocks",
  "order.order.getsolution",
  "order.order.stats",
  "order.order.testY2WS",
  "ole.log.list",
  "ole.log.edit",
  "systeme.infos",
  "systeme.changelog",
  "depot.list",
  "user.liste",
  "user.byId",
  "user.preferences.saveSort",
  "user.preferences.saveFilters",
  "user.preferences.saveVersionVue",
]);

const entrees = new Map();
// Incrémentée à chaque vidage : une réponse demandée avant un vidage n'est pas mise en cache
let generation = 0;

export function cacheKey(ecran, parametres) {
  return ecran + ":" + JSON.stringify(parametres);
}

export function getCached(cle) {
  return entrees.get(cle);
}

// `gen` : valeur de cacheGeneration() relevée avant d'envoyer la requête
export function setCached(cle, valeur, gen) {
  if (gen !== generation) return;
  entrees.delete(cle);
  entrees.set(cle, valeur);
  if (entrees.size > MAX_ENTREES) entrees.delete(entrees.keys().next().value);
}

export function cacheGeneration() {
  return generation;
}

export function clearCache() {
  entrees.clear();
  generation++;
}

// Appelée par l'Echangeur avec les fonctions d'une requête, avant l'envoi et après la réponse
export function noteFonctions(fonctions) {
  if (fonctions.some((f) => !LECTURES.has(f))) clearCache();
}
